import { Expose } from "class-transformer";

export class UpdateServiceDto {
  @Expose()
  id: string;

  @Expose()
  name: string;

  @Expose()
  externalCode?: string;
}
